import React from 'react'
import cn from 'classnames'
import { Waves } from 'lucide-react'
import styles from 'components/shared/icons/icons.module.scss'

interface StreamsIconProps {
    contextStyles?: string
    size?: number
    iconClassName?: string
    hoverStyles?: string
    selectedStyles?: string
}

export default function StreamsIcon({
    contextStyles,
    hoverStyles,
    selectedStyles,
    size = 20,
    iconClassName,
}: StreamsIconProps) {
    return (
        <div className={cn(styles.streamsIconWrapper, contextStyles, hoverStyles, selectedStyles)}>
            <Waves size={size} className={cn(styles.streamsIcon, iconClassName)} />
        </div>
    )
}
